import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import ProviderForm from "./ProviderForm";
import PatientManagement from "./PatientManagement";
import ChangePasswordForm from "./ChangePasswordForm";
import EmailPreferences from "../components/EmailPreferences";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const TabbedProfile: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 800, mx: "auto", mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Profile
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="profile tabs">
          <Tab label="Provider" id="profile-tab-0" aria-controls="profile-tabpanel-0" />
          <Tab label="Patients" id="profile-tab-1" aria-controls="profile-tabpanel-1" />
          <Tab label="Security" id="profile-tab-2" aria-controls="profile-tabpanel-2" />
          <Tab label="Notifications" id="profile-tab-3" aria-controls="profile-tabpanel-3" />
        </Tabs>
      </Box>
      <TabPanel value={tabValue} index={0}>
        <ProviderForm />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <PatientManagement />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <ChangePasswordForm tokenKey="providerToken" />
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <EmailPreferences
          tokenKey="providerToken"
          emailTypes={[
            { key: "clarification_needed", label: "Clarification needed on an order" },
            { key: "received_by_pharmacy", label: "Order received by pharmacy" },
          ]}
        />
      </TabPanel>
    </Box>
  );
};

export default TabbedProfile;
